module.exports = __webpack_public_path__ + "img/mariadb.c0b5e34f.jpg";